module.exports = __webpack_public_path__ + "media/images/new_landing/hp/forIfluencers-ee1a7a87b95a3989a648711fd764032f.jpg";